import { SimpleAttributePermissionRuleCoreBase } from "./simple-attribute-permission-rule.core.base"


export class SimpleAttributePermissionRuleCore extends SimpleAttributePermissionRuleCoreBase {

}